// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"LinkBtn_btnTextStyle_1MARl"};